import * as Yup from 'yup';

const BancoInterValidationSchema = Yup.object().shape({
  payment_gateway_id: Yup.string().required('ID do Gateway é obrigatório').nullable(true),
  mnemonic: Yup.string().required('Mnemônico é obrigatório').nullable(true),
  client_id: Yup.string().required('Client ID é obrigatório').nullable(true),
  client_secret: Yup.string().required('Client Secret é obrigatório').nullable(true),
  certificate_crt: Yup.mixed().required('Certificado .crt é obrigatório').nullable(true),
  certificate_key: Yup.mixed().required('Certificado .key é obrigatório').nullable(true),
});

export default BancoInterValidationSchema;
